module.exports = __webpack_public_path__ + "img/you-logo.960e2406.png";